import React, { useState } from 'react';
import { exemplarApi } from '../../API/exemplar';
import { RelatedObject, RelatedType } from '../../types';
import { DeleteModal } from './DeleteModal';
import { ErrorModal } from '../Modal/ErrorModal';

interface IDeleteTool {
  savedData: RelatedObject;
  mainColor: string;
  highlightColor: string;
  setShowModal: (isOpened: boolean) => void;
  onDelete: (id: number) => void;
}

export const DeleteTool = (props: IDeleteTool): JSX.Element => {
  const { savedData, mainColor, highlightColor, setShowModal, onDelete } = props;
  const { id, type, title } = savedData;

  const [isSuccessfullyDeleted, setSuccessfullyDeleted] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  const { deleteSavedExemplar, deleteSavedProforma } = exemplarApi;

  const deleteSavedData = type === RelatedType.saved_exemplars ? deleteSavedExemplar : deleteSavedProforma;

  const handleDeleteExemplar = async (id: number | undefined) => {
    if (id) {
      try {
        setLoading(true);
        const {
          data: { status },
        } = await deleteSavedData(id);
        setSuccessfullyDeleted(status);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleRetryClick = () => {
    setError(false);
    setShowModal(true);
    handleDeleteExemplar(id);
  };

  const handleCloseModal = () => {
    if (isSuccessfullyDeleted) {
      setSuccessfullyDeleted(false);
      setShowModal(false);
      onDelete(id);
    } else {
      setShowModal(false);
    }
  };

  if (isError) {
    return (
      <ErrorModal
        errorType="delete"
        title={title}
        mainColor={mainColor}
        highlightColor={highlightColor}
        onCloseClick={() => {
          setError(false);
          setShowModal(false);
        }}
        onRetryClick={handleRetryClick}
      />
    );
  }
  return (
    <DeleteModal
      isLoading={isLoading}
      savedData={savedData}
      isSuccessfullyDeleted={isSuccessfullyDeleted}
      mainColor={mainColor}
      highlightColor={highlightColor}
      handleDeleteExemplar={handleDeleteExemplar}
      onClose={handleCloseModal}
    />
  );
};
